import "./logging";

import "core-js/stable";
import "regenerator-runtime/runtime";

import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";
import Axios from "axios";
import store from "sports4me-web_components/utils/store.js";
import api from "sports4me-web_components/utils/api.js";
import moment from "moment";
import "moment/locale/de";
import Cookies from "js-cookie";
import VModal from 'vue-js-modal';

// need for IE compatiblity
import Promise from "es6-promise";
require("es6-promise").polyfill();
Promise.polyfill();

// Plugins
import App from "./App.vue";

// router setup
import routes from "./routes/routes";
import i18n from 'sports4me-web_components/utils/i18n';

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(VModal);

Vue.use(require("vue-moment"), {
  moment
});

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "nav-item active"
});

router.beforeEach((to, from, next) => {
  // Check if route is protected
  if (to.meta && to.fullPath && to.meta.authRed && to.meta.authRed === true && store.getters.isLoggedIn) {
    next({
      path: to.fullPath.replace("/",'/_')
    });
    return;
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      // if user is logged in: let re redirect go through
      if (from.query && from.query.redirect && from.query.redirect !== to.fullPath) {
        next(from.query.redirect);
      } else {
        next();
      }
      return;
    }
    // if not go to /login
    // /#/Challenges/5fe188ca6da3011eaed12896?join-code=6UMHKGSB
    next({
      path: "/login",
      query: { redirect: `${to.fullPath}` }
    });
  } else {
    if (from.meta && from.meta.canRedirectAfterLogin && from.query && from.query.redirect && to.meta.canRedirectAfterLogin && !to.query.redirect) {
      next({
        path: to.path,
        query: { redirect: from.query.redirect, ...to.query }
      });
    } else {
      next();
    }
  }
});

router.beforeEach(async (to, from, next) => {
  if (!store.getters.user) {
    if (to.matched.some(route => route.meta.requiresAuth)) {
      await store.dispatch('getUser');

      if (store.getters.user) {
        return next();
      }
      return router.push('/login');
    }
  }

  return next();
});

// global library setup
Vue.prototype.$http = Axios;
Vue.material.locale.dateFormat = "dd.MM.yyyy";

const token = Cookies.get("token");
if (token) {
  // TODO: just needed cause the api.js is loaded here, move axion only to web_components
  Vue.prototype.$http.defaults.headers.common["Authorization"] = "Bearer " + token;
  store.dispatch("getUser");
} else console.log("no token found");

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store,
  i18n,
  api
});
